import { TFunction } from "i18next";
import * as Yup from "yup";

export const MIN_PASSWORD_LENGTH = 8;

export const email_validation_regex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const loginSchema = (t: TFunction) =>
    Yup.object({
        email: Yup.string()
            .required(t("login.email_required"))
            .email(t("login.invalid_format"))
            .matches(email_validation_regex, t("login.invalid_format")),
        password: Yup.string()
            .required(t("login.password_required"))
            .min(
                MIN_PASSWORD_LENGTH,
                t("login.password_length", { length: MIN_PASSWORD_LENGTH }),
            ),
    });
